import ButtonComponent from "@/components/Button";
import LinkComponent from "next/link";
import { SVGArrowRight as SVGArrowRightComponent } from "@/lib/svg";
import { JobApplicationContainer, Heading, Excerpt } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Button = ButtonComponent as any;
const Link = LinkComponent as any;
const SVGArrowRight = SVGArrowRightComponent as any;

export type JobApplicationProps = {
  id?: string;
  heading?: string;
  excerpt?: string;
  linkTitle?: string;
  url?: string | null;
};
const JobApplication: React.FC<JobApplicationProps> = (props) => {
  const { heading, excerpt, linkTitle, url } = props;
  return (
    <JobApplicationContainer>
      {heading && <Heading as="p">{heading}</Heading>}
      {excerpt && <Excerpt>{excerpt}</Excerpt>}
      {linkTitle && url && (
        <Link href={url} passHref>
          <Button
            as="a"
            variant="primaryUnboxed"
            icon={<SVGArrowRight />}
            target={"_blank"}
            style={{
              width: "fit-content",
              paddingLeft: 0,
              marginRight: "1rem",
            }}
          >
            {linkTitle}
          </Button>
        </Link>
      )}
    </JobApplicationContainer>
  );
};

export default JobApplication;
